import _extends from "@babel/runtime-corejs3/helpers/extends";

var _context;

import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import * as _ from "../util/lodash";
var positions = {
  LEFT: 'left',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  TOP: 'top',
  TOP_RIGHT: 'top right',
  TOP_LEFT: 'top left',
  BOTTOM_LEFT: 'bottom left',
  BOTTOM_RIGHT: 'bottom right'
};
positions.ALL = _valuesInstanceProperty(_).call(_, positions); //used only in the toolbar header arrangement - left or center

positions.CENTER = 'center';
positions.WITHOUT_SIDES = _valuesInstanceProperty(_).call(_, _.omit(positions, ['LEFT', 'RIGHT', 'ALL']));
positions.LEFT_RIGHT = 'left right';
positions.LRTB = [positions.LEFT, positions.RIGHT, positions.TOP, positions.BOTTOM];
positions.LR = [positions.LEFT, positions.RIGHT];
positions.LRLR = [positions.LEFT, positions.RIGHT, positions.LEFT_RIGHT];
positions.pointing = {
  ABOVE: 'above',
  BELOW: 'below'
};
positions.pointing.ALL = _concatInstanceProperty(_context = []).call(_context, positions.LR, _valuesInstanceProperty(_).call(_, positions.pointing));
positions.verticalAlign = {
  TOP: 'top',
  MIDDLE: 'middle',
  BOTTOM: 'bottom'
};
positions.alignColumns = _extends({}, positions.verticalAlign, {
  FLEX: 'flex'
});
positions.inSquare = {
  TOP_LEFT: 'top left',
  TOP_CENTER: 'top center',
  TOP_RIGHT: 'top right',
  MIDDLE_LEFT: 'middle left',
  CENTERED: 'middle center',
  MIDDLE_RIGHT: 'middle right',
  BOTTOM_LEFT: 'bottom left',
  BOTTOM_CENTER: 'bottom center',
  BOTTOM_RIGHT: 'bottom right'
};
positions.inSquare.ALL = _valuesInstanceProperty(_).call(_, positions.inSquare);
positions.alignColumns.ALL = _valuesInstanceProperty(_).call(_, positions.alignColumns);
positions.verticalAlign.ALL = _valuesInstanceProperty(_).call(_, positions.verticalAlign);
export default positions;
//# sourceMappingURL=positions.js.map